<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item  label="选择负责人：" prop="memberId">
        <el-select v-model="form.memberId" filterable remote :remote-method="loadMember" :loading="loading"  placeholder="可输入姓名 | 手机号 | 部门名称进行搜索">
          <el-option
              v-for="item in memberList"
              :key="item.id"
              :label="item.name +' | '+(item.phone||'无')+' | '+ item.companyName"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.type==3" label="是否企微通知" prop="isQw" class="form-item-switch"  >
        <el-switch v-model="form.isQw"  :active-value="1" :inactive-value="0"/>
        <span class="switch-text"> </span>
      </el-form-item>
      <el-form-item v-if="form.type==3" label="是否邮件通知" prop="isEmail" class="form-item-switch"  >
        <el-switch v-model="form.isEmail"  :active-value="1" :inactive-value="0"/>
        <span class="switch-text"></span>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import { allList } from '@/api/business/member'

export default {
  name: 'OperaManagersWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        type: '',
        memberId: '',
        remark: '',
        isQw: 0,
        isEmail: 0
      },
      loading: false,
      memberList: [],
      // 验证规则
      rules: {
        memberId: [
          { required: true, message: '请选择负责人' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/business/managers',
      'field.id': 'id'
    })
  },
  methods: {
    loadMember (query) {
      this.memberList = []
      if (!query || query == '') {
        return
      }
      this.loading = true
      allList({
        keyword: query
      })
        .then(res => {
          this.memberList = res
        })
        .catch(e => {
        })
        .finally(() => {
          this.loading = false
        })
    },
    open (title, target) {
      this.title = title
      this.visible = true
      // 新建
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.form.type = target != null ? target.type : null
        this.form[this.configData['field.id']] = null
      })
      this.memberList = []
      // this.loadMember()
    }
  }
}
</script>
